var boostPFSFilterConfig = { general: { limit: boostPFSConfig.custom.products_per_page, loadProductFirst: !0 }, selector: { trackingQuickView: ".quick_shop" } };
!(function () {
  function e(e) {
    var t = "";
    var i = [];
    if (boostPFSConfig.custom.stickers_enabled) {
      var o = e.collections.map((e) => e.handle);
      var a = ["best-seller", "coming-soon", "new", "pre-order", "staff-pick"];
      for (var s = 0; s < a.length; s++) {
        var r = a[s];
        if (-1 != o.indexOf(r)) {
          var l = boostPFSConfig.label[r.replace("-", "_")];
          var n = '<div class="' + r + "-sticker thumbnail-sticker sticker-" + s + '"><span class="sticker-text">' + l + "</span></div>";
          i.push(n);
        }
      }
      var c;
      if (e.available && e.price_min < e.compare_at_price_max) {
        var n = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + "</span></div>";
        i.push(n);
      }
      i.length > 0 &&
        (t =
          '<div class="sticker-holder sticker-shape-' +
          boostPFSConfig.custom.sticker_shape +
          " sticker-position-" +
          boostPFSConfig.custom.sticker_position +
          '">' +
          '<div class="sticker-holder__content sticker-holder__content--">' +
          i.join("") +
          "</div>" +
          "</div>");
    }
    return t;
  }
  function t(e) {
    var t = "";
    var o = e.images_info;
    return (
      (o && 0 != o.length) || o.push({ src: boostPFSAppConfig.general.no_image_url, width: 480, height: 480 }),
      (t += i(o[0])),
      boostPFSConfig.custom.show_secondary_image && o.length > 1 && (t += i(o[1], "lazypreload secondary swap--visible")),
      t
    );
  }
  function i(e, t) {
    var t = "undefined" != typeof t ? t : "";
    var i = "";
    var o = "";
    var a = "";
    var s = e.width / e.height;
    boostPFSConfig.custom.align_height && ((o += "max-height: " + boostPFSConfig.custom.collection_height + "px;"), (a += "width: calc(" + e.width + " / " + e.height + " * " + boostPFSConfig.custom.collection_height + "px)"));
    var l = "color" == boostPFSConfig.custom.image_loading_style ? "background: url(" + Utils.optimizeImage(e.src, "1x") + "); " : "";
    var n = "blur-up" == boostPFSConfig.custom.image_loading_style ? Utils.optimizeImage(e.src, "50x") : "";
    return (i +=
      '<div class="image-element__wrap" style="' +
      l +
      o +
      a +
      '">' +
      '<img alt="{{itemTitle}}"' +
      ' class="lazyload transition--' +
      boostPFSConfig.custom.image_loading_style +
      " " +
      t +
      '"' +
      (n && "" !== n ? ' src="' + n + '"' : "") +
      ' data-src="' +
      Utils.optimizeImage(e.src, "1600x") +
      '"' +
      ' data-sizes="auto"' +
      ' data-aspectratio="' +
      s +
      '"' +
      ' data-srcset="' +
      r(e) +
      '"' +
      ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
      ' height="' +
      e.height +
      '"' +
      ' width="' +
      e.width +
      '"' +
      ' style="' +
      o +
      '"' +
      "/>" +
      "</div>");
  }
  function o(e) {
    var t = "";
    if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled) {
      if (((t = boostPFSTemplate.itemHoverHtml), boostPFSConfig.custom.thumbnail_hover_enabled)) {
        var i = '<div class="quick-shop__info">' + '<div class="thumbnail-overlay">' + '<div class="info text-align-center">' + "{{itemProductInfo}}" + "</div>" + "</div>" + "</div>";
        t = t.replace(/{{itemProductInfoHover}}/g, i);
      } else t = (t = t.replace(/{{itemProductInfoHover}}/g, "")).replace(/{{itemReviews}}/g, "");
      boostPFSConfig.custom.enable_quickshop || (t = t.replace(/{{itemQuickShop}}/g, ""));
    }
    return t;
  }
  function a(e) {
    var t = "";
    var i = e.compare_at_price_max > e.price_min;
    var o = !e.available;
    var a = e.price_max != e.price_min;
    return (
      (t += '<span class="product-thumbnail__price price ' + (i ? "sale" : "") + '"> '),
      o
        ? (t += '<span class="product-thumbnail__sold-out sold-out">' + boostPFSConfig.label.sold_out + "</span>")
        : (e.price_min > 0 ? (a && (t += "<small><em>" + boostPFSConfig.label.from + "</em></small> "), (t += '<span class="money">' + Utils.formatMoney(e.price_min) + "</span> ")) : (t += boostPFSConfig.custom.free_price_text),
          i && (t += '<span class="product-thumbnail__was-price was-price">' + '<span class="money">' + Utils.formatMoney(e.compare_at_price_max) + "</span>" + "</span>")),
      t
    );
  }
  function s(e) {
    var t = "";
    var i = [];
    var o = [];
    return (
      boostPFSConfig.custom.collection_swatches &&
        e.variants.forEach(function (t) {
          var a = "";
          var s = "";
          if (
            (t.merged_options.forEach(function (e) {
              var t = e.split(":")[0];
              var o = e.split(":")[1];
              (-1 == t.toLowerCase().indexOf("color") && -1 == t.toLowerCase().indexOf("colour")) || -1 != i.indexOf(o.toLowerCase()) || (i.push(o.toLowerCase()), (a = o), (s = t));
            }),
            a)
          ) {
            var r =
              '<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
              '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-image: url({{variantImage}});">' +
              '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
              "</span>" +
              "</a>";
            r = (r = (r = (r = (r = r.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape)).replace(/{{colorBackground}}/g, Utils.slugify(a).split("-").pop())).replace(
              /{{slugifyOptionValue}}/g,
              Utils.slugify(s).replace("-", "_")
            )).replace(/{{slugifyColorValue}}/g, Utils.slugify(a).replace("-", "_"))).replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(e) + "?variant=" + t.id);
            var l = boostPFSAppConfig.general.file_url.split("?")[0] + Utils.slugify(a) + "_50x.png";
            r = r.replace(/{{colorImage}}/g, l);
            var n = "";
            var c = "";
            if (t.image)
              switch (boostPFSConfig.custom.products_per_row) {
                case 2:
                  n = Utils.optimizeImage(t.image, "600x");
                  break;
                case 3:
                  n = Utils.optimizeImage(t.image, "500x");
                  break;
                default:
                  n = Utils.optimizeImage(t.image, "400x");
                  break;
              }
            (r = r.replace(/{{variantImage}}/g, n)), o.push(r);
          }
        }),
      o.length > 0 && (t = '<div class="thumbnail-swatch is-justify-' + boostPFSConfig.custom.thumbnail_text_alignment + ' is-flex-wrap">' + o.join(" ") + "</div>"),
      t
    );
  }
  function r(e) {
    var t = "";
    if (e) {
      var i = e.width / e.height;
      e.width > 180 && (t += " " + Utils.optimizeImage(e.src, "180x") + " 180w " + Math.round(180 / i) + "h,"),
        e.width > 360 && (t += " " + Utils.optimizeImage(e.src, "360x") + " 360w " + Math.round(360 / i) + "h,"),
        e.width > 540 && (t += " " + Utils.optimizeImage(e.src, "540x") + " 540w " + Math.round(540 / i) + "h,"),
        e.width > 720 && (t += " " + Utils.optimizeImage(e.src, "720x") + " 720w " + Math.round(720 / i) + "h,"),
        e.width > 900 && (t += " " + Utils.optimizeImage(e.src, "900x") + " 900w " + Math.round(900 / i) + "h,"),
        e.width > 1080 && (t += " " + Utils.optimizeImage(e.src, "1080x") + " 1080w " + Math.round(1080 / i) + "h,"),
        e.width > 1296 && (t += " " + Utils.optimizeImage(e.src, "1296x") + " 1296w " + Math.round(1296 / i) + "h,"),
        e.width > 1512 && (t += " " + Utils.optimizeImage(e.src, "1512x") + " 1512w " + Math.round(1512 / i) + "h,"),
        e.width > 1728 && (t += " " + Utils.optimizeImage(e.src, "1728x") + " 1728w " + Math.round(1728 / i) + "h,"),
        e.width > 1950 && (t += " " + Utils.optimizeImage(e.src, "1950x") + " 1950w " + Math.round(1950 / i) + "h,"),
        e.width > 2100 && (t += " " + Utils.optimizeImage(e.src, "2100x") + " 2100w " + Math.round(2100 / i) + "h,"),
        e.width > 2260 && (t += " " + Utils.optimizeImage(e.src, "2260x") + " 2260w " + Math.round(2260 / i) + "h,"),
        e.width > 2450 && (t += " " + Utils.optimizeImage(e.src, "2450x") + " 2450w " + Math.round(2450 / i) + "h,"),
        e.width > 2700 && (t += " " + Utils.optimizeImage(e.src, "2700x") + " 2700w " + Math.round(2700 / i) + "h,"),
        e.width > 3e3 && (t += " " + Utils.optimizeImage(e.src, "3000x") + " 3000w " + Math.round(3e3 / i) + "h,"),
        e.width > 3350 && (t += " " + Utils.optimizeImage(e.src, "3350x") + " 3350w " + Math.round(3350 / i) + "h,"),
        e.width > 3750 && (t += " " + Utils.optimizeImage(e.src, "3750x") + " 3750w " + Math.round(3750 / i) + "h,"),
        e.width > 4100 && (t += " " + Utils.optimizeImage(e.src, "4100x") + " 180w " + Math.round(4100 / i) + "h,"),
        (t += " " + e.src + " " + e.width + "w " + e.height + "h,");
    }
    return t;
  }
  function l() {
    window.SPR && "function" == typeof SPR.initDomEls && "function" == typeof SPR.loadBadges && (SPR.initDomEls(), SPR.loadBadges()),
      "undefined" != typeof Shopify.PaymentButton && "function" == typeof Shopify.PaymentButton.init && Shopify.PaymentButton.init(),
      boostPFSConfig.custom.hasOwnProperty("show_multiple_currencies") && 1 == boostPFSConfig.custom.show_multiple_currencies && "function" == typeof convertCurrencies && convertCurrencies();
  }
  BoostPFS.inject(this),
    (ProductGridItem.prototype.compileTemplate = function (i, r, l) {
      i || (i = this.data), r || (r = this.index), l || (l = this.totalProduct);
      var n = boostPFSTemplate.productGridItemHtml;
      var c = "one-third";
      switch (boostPFSConfig.custom.products_per_row) {
        case 1:
          c = "one-whole";
          break;
        case 2:
          c = "one-half";
          break;
        case 3:
          c = "one-third";
          break;
        case 4:
          c = "one-fourth";
          break;
        case 5:
          c = "one-fifth";
          break;
        case 6:
          c = "one-sixth";
          break;
        case 7:
          c = "one-seventh";
          break;
        case 8:
          c = "one-eighth";
          break;
      }
      n = (n = (n = (n = (n = (n = (n = (n = n.replace(/{{itemDesktopWidthClass}}/g, c)).replace(/{{itemMobileWidthClass}}/g, 1 == boostPFSConfig.custom.mobile_products_per_row ? "small-down--one-whole" : "small-down--one-half")).replace(
        /{{itemQuickShopClass}}/g,
        boostPFSConfig.custom.enable_quickshop ? "quick-shop--true quick-shop--closed product-{{itemId}} js-product_section" : ""
      )).replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? "has-thumbnail-sticker" : "")).replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled.toString())).replace(
        /{{itemSwapImageClass}}/g,
        boostPFSConfig.custom.show_secondary_image && i.images_info.length > 1 ? "swap--true" : ""
      )).replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && i.images_info.length > 1 ? "has-secondary-image-swap" : "")).replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);
      var m = e(i);
      n = n.replace(/{{itemStickers}}/g, m);
      var p = t(i);
      n = n.replace(/{{itemImages}}/g, p);
      var g = o(i);
      n = (n = n.replace(/{{itemHover}}/g, g)).replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);
      var u = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : "";
      var h;
      var d;
      (n = n.replace(/{{itemVendor}}/g, u)),
        (n =
          -1 != i.collections.map((e) => e.handle).indexOf("coming-soon")
            ? (n = n.replace(/{{itemComingSoon}}/g, "<span>" + boostPFSConfig.label.coming_soon + "</span>")).replace(/{{itemPrice}}/g, "")
            : (n = n.replace(/{{itemComingSoon}}/g, "")).replace(/{{itemPrice}}/g, a(i)));
      var f = s(i);
      if (((n = n.replace(/{{itemSwatch}}/g, f)), "undefined" == typeof Integration || !Integration.hascompileTemplate("reviews"))) {
        var v = boostPFSConfig.custom.enable_shopify_collection_badges && boostPFSConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : "";
        n = boostPFSConfig.custom.thumbnail_hover_enabled ? (n = n.replace(/{{itemReviewsHover}}/g, v)).replace(/{{itemReviews}}/g, "") : (n = n.replace(/{{itemReviewsHover}}/g, "")).replace(/{{itemReviews}}/g, v);
      }
      var b = boostPFSConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : "";
      return (n = (n = (n = (n = (n = (n = n.replace(/{{itemQuickShop}}/g, b)).replace(/{{itemId}}/g, i.id)).replace(/{{itemTitle}}/g, i.title)).replace(/{{itemHandle}}/g, i.handle)).replace(/{{itemVendor}}/g, i.vendor)).replace(
        /{{itemUrl}}/g,
        Utils.buildProductItemUrl(i)
      ));
    }),
    (ProductPaginationDefault.prototype.compileTemplate = function (e) {
      e || (e = this.totalProduct);
      var t = parseInt(Globals.queryParams.page);
      var i = Math.ceil(e / Globals.queryParams.limit);
      if (i > 1) {
        var o = boostPFSTemplate.paginateHtml;
        var a = t > 1 ? boostPFSTemplate.previousActiveHtml : "";
        (a = a.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", t, t - 1))), (o = o.replace(/{{previous}}/g, a));
        var s = t < i ? boostPFSTemplate.nextActiveHtml : "";
        (s = s.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", t, t + 1))), (o = o.replace(/{{next}}/g, s));
        var r = [];
        for (var l = t - 1; l > t - 3 && l > 0; l--) r.unshift(l);
        t - 4 > 0 && r.unshift("..."), t - 4 >= 0 && r.unshift(1), r.push(t);
        var n = [];
        for (var c = t + 1; c < t + 3 && c <= i; c++) n.push(c);
        t + 3 < i && n.push("..."), t + 3 <= i && n.push(i);
        var m = "";
        var p = r.concat(n);
        for (var g = 0; g < p.length; g++)
          "..." == p[g] ? (m += boostPFSTemplate.pageItemRemainHtml) : (m += p[g] == t ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml),
            (m = (m = m.replace(/{{itemTitle}}/g, p[g])).replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", t, p[g])));
        return (o = o.replace(/{{pageItems}}/g, m));
      }
      return "";
    }),
    (ProductSorting.prototype.compileTemplate = function () {
      if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
        var e = Utils.getSortingList();
        if (e) {
          var t = "";
          for (var i in e) t += '<option value="' + i + '">' + e[i] + "</option>";
          var o;
          return boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, t);
        }
      }
      return "";
    }),
    (ProductList.prototype.afterRender = function (e, t) {
      if ((e || (e = this.data), t || (t = this.eventType), boostPFSConfig.custom.enable_quickshop && e.length > 0)) {
        var i = 0;
        e.forEach(function (t) {
          var o = Utils.buildProductItemUrl(t, !0);
          jQ.ajax({
            type: "GET",
            url: o + "?view=boost-pfs-quickview",
            success: function (o) {
              1 == jQ('[data-boost-pfs-quickshop-id="' + t.id + '"]').length && jQ('[data-boost-pfs-quickshop-id="' + t.id + '"]').replaceWith(o), ++i == e.length && l();
            },
          });
        });
      } else l();
    }),
    (FilterResult.prototype.afterRender = function (e, t) {});
  
    // boost-pfs-filter.js
    FilterApi.beforeCall = function(eventType, eventInfo) {
        if (Utils.isSearchPage() && Globals.queryParams.q) {
          Globals.queryParams.q = Globals.queryParams.q.replace(/-/g, ' ');
        }
    }

    // boost-pfs-instant-search.js
    InstantSearchApi.beforeCall = function(searchTerm) {
        if (Globals.instantSearchQueryParams.q) {
          Globals.instantSearchQueryParams.q = Globals.instantSearchQueryParams.q.replace(/-/g, ' ');
        }    
    }
})();
//# sourceMappingURL=/s/files/1/0248/6779/9085/t/32/assets/boost-pfs-filter.js.map?v=1637271534
